export default "__VITE_ASSET__Dwsz9A3h__"